export default "__VITE_ASSET__DofaH6Z4__"